import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { array } from 'fp-ts';
import { map } from 'lodash/fp';
import { composeProps, createPropsExtender, LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseReservationsCustomerIds } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { getCheckedReservationIds } from '../../selectors';
import { getCustomerBalancesByCustomerIds, getCustomersTotalBalance } from '../../ducks/balances';
import { CustomerLink } from '../../../../components/commander-ui';

export const getCheckedReservationCustomerIds = composeProps(
    getCurrentEnterpriseReservationsCustomerIds,
    createPropsExtender('ids', getCheckedReservationIds)
);

const getCustomersBalances = flow(
    composeProps(getCustomerBalancesByCustomerIds, createPropsExtender('ids', getCheckedReservationCustomerIds)),
    array.map((balance) => ({ ...balance, id: balance.customerId }))
);

export const getTotalBalance = composeProps(
    getCustomersTotalBalance,
    createPropsExtender('ids', getCheckedReservationCustomerIds)
);

export const getTableSource = createSelector(getCustomersBalances, getTotalBalance, (balances, totalBalance) => [
    ...map(
        ({ id, balance, openItemCount }) => ({
            label: <CustomerLink id={id} />,
            balance: <LocalizedCurrencyValue value={balance} />,
            id,
            openItemCount,
        }),
        balances
    ),
    {
        label: (
            <strong>
                <LocalizedText textKey={TextKey.Total} />
            </strong>
        ),
        balance: (
            <strong>
                <LocalizedCurrencyValue value={totalBalance} />
            </strong>
        ),
    },
]);
